import React, { useEffect, useState } from 'react';
import { FaPlus } from "react-icons/fa6";
import { RiDeleteBin6Line } from "react-icons/ri";
import { FaRegEdit } from "react-icons/fa";
import axios from '../../api/axios';
import { useNavigate } from "react-router-dom";

const PRODUCTS_URL = '/api/product';
const BACK_END_URL = "https://shtato-b15797a0a9a3.herokuapp.com/";

const MenuList = () => {
    const [products, setProducts] = useState([]);
    const [selectedType, setSelectedType] = useState("food");
    const [selectedCategory, setSelectedCategory] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [productToDelete, setProductToDelete] = useState(null);
    const navigate = useNavigate();

    const typeCategories = {
        food: [
            "SALAD",
            "BURGER",
            "SANDWICH",
            "OMELETTE",
            "PLATS",
            "HARIRA",
            "TAGINE",
            "COUSCOUS",
            "DESSERTS"
        ],
        drinks: [
            "COFFEE",
            "JUICE",
            "MOCKTAILS",
            "TEA",
            "WATERS",
            "BEER",
        ]
    };

    useEffect(() => {
        fetchProducts();
    }, []);

    const fetchProducts = async () => {
        try {
            const response = await axios.get(PRODUCTS_URL);
            setProducts(response?.data);
        } catch (error) {
            console.log(error);
        }
    };

    const handleDelete = async (id) => {
        try {
            await axios.delete(`${PRODUCTS_URL}/${id}`);
            fetchProducts();
            setIsModalOpen(false);
        } catch (error) {
            console.log("Error deleting product:", error);
        }
    };

    const openModal = (productId) => {
        setProductToDelete(productId);
        setIsModalOpen(true);
    };

    const handleTypeChange = (type) => {
        setSelectedType(type);
        setSelectedCategory("");
    };

    const filteredProducts = products.filter(product => {
        if (!selectedType) return true;
        if (!selectedCategory) {
            return typeCategories[selectedType].includes(product.category);
        }
        return product.category === selectedCategory;
    });

    return (
        <div className="p-6">
            <div className="flex justify-between items-center">
                <h2 className="text-3xl font-bold tracking-tight text-[#610c63]">Menu</h2>
                <div className="flex items-center space-x-4">
                    <button
                        onClick={() => navigate('/menu/add')}
                        className="bg-[#4335A7] text-white py-2 uppercase px-4 rounded-lg flex items-center hover:bg-[#4e0a50] transition duration-200"
                    >
                        <FaPlus size={20} />
                    </button>
                </div>
            </div>

            <div className="mb-6 flex justify-center space-x-4">
                <button
                    onClick={() => handleTypeChange('food')}
                    className={`px-6 py-3 rounded-lg text-lg font-semibold transition duration-200 ${selectedType === 'food'
                            ? 'bg-[#4335A7] text-white'
                            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                        }`}
                >
                    Food
                </button>
                <button
                    onClick={() => handleTypeChange('drinks')}
                    className={`px-6 py-3 rounded-lg text-lg font-semibold transition duration-200 ${selectedType === 'drinks'
                            ? 'bg-[#4335A7] text-white'
                            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                        }`}
                >
                    Drinks
                </button>
            </div>

            {selectedType && (
                <div className="mb-8 flex flex-wrap justify-center gap-3">
                    <button
                        onClick={() => setSelectedCategory("")}
                        className={`px-4 py-2 rounded-lg text-sm font-medium transition duration-200 ${!selectedCategory
                                ? 'bg-[#4335A7] text-white'
                                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                            }`}
                    >
                        All {selectedType.charAt(0).toUpperCase() + selectedType.slice(1)}
                    </button>
                    {typeCategories[selectedType].map((category) => (
                        <button
                            key={category}
                            onClick={() => setSelectedCategory(category)}
                            className={`px-4 py-2 rounded-lg text-sm font-medium transition duration-200 ${selectedCategory === category
                                    ? 'bg-[#4335A7] text-white'
                                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                }`}
                        >
                            {category}
                        </button>
                    ))}
                </div>
            )}

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                {filteredProducts.map((product) => (
                    <div
                        key={product._id}
                        className="bg-white rounded-md border border-gray-200 overflow-hidden hover:shadow-md transition-shadow relative"
                    >
                        {product.logo && (
                            <div className="w-full h-32 overflow-hidden bg-gray-100">
                                <img
                                    src={`${BACK_END_URL}images/` + product.logo}
                                    alt={product.name}
                                    className="w-full h-full object-cover"
                                />
                            </div>
                        )}

                        <div className="p-2">
                            <div className="flex items-center justify-between gap-1 mb-2">
                                <h3 className="text-base font-semibold">{product.name}</h3>
                                <span className="px-2 py-0.5 rounded bg-blue-100 text-blue-700 text-xs font-medium">
                                    {product.category}
                                </span>
                            </div>

                            <div className="flex justify-between items-center pt-2 border-t border-gray-100">
                                <div className="flex items-center gap-1 text-green-600 font-semibold text-sm">
                                    {product.price.toFixed(2)} DH
                                </div>
                            </div>
                        </div>

                        <div className="absolute bottom-1 right-1">
                            <button
                                onClick={() => navigate(`/menu/edit/${product._id}`)}
                                className="bg-blue-600 text-white p-1.5 rounded-md hover:bg-blue-700 transition"
                            >
                                <FaRegEdit size={16} />
                            </button>
                        </div>

                        <div className="absolute top-1 right-1">
                            <button
                                onClick={() => openModal(product._id)}
                                className="flex items-center justify-center p-2 bg-red-600 text-white rounded-full shadow hover:bg-red-700 transition"
                            >
                                <RiDeleteBin6Line size={18} />
                            </button>
                        </div>
                    </div>
                ))}
            </div>

            {isModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center bg-gray-600 bg-opacity-50 z-50">
                    <div className="bg-white rounded-lg p-6 w-1/3 shadow-lg">
                        <h2 className="text-lg font-semibold mb-4">Confirm Deletion</h2>
                        <p>Are you sure you want to delete this product?</p>
                        <div className="mt-4 flex justify-end space-x-2">
                            <button
                                onClick={() => setIsModalOpen(false)}
                                className="bg-gray-300 text-gray-700 py-2 px-4 rounded-lg hover:bg-gray-400 transition duration-200"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={() => {
                                    if (productToDelete) {
                                        handleDelete(productToDelete);
                                    }
                                }}
                                className="bg-red-600 text-white py-2 px-4 rounded-lg hover:bg-red-700 transition duration-200"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default MenuList;